import {
  JoonColorExpanded,
  JoonUIColor,
  QuestStatus,
  SPACING,
  Typography,
} from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

const StatusBadge = ({ status }: { status: QuestStatus }) => {
  const { t } = useTranslation()
  const badgeInfo = getBadgeInfo(status)

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        borderRadius: SPACING.space2,
        height: "fit-content",
        width: "fit-content",
        padding: `${SPACING.space1} ${SPACING.space2}`,
        background: badgeInfo.color,
      }}
    >
      <Typography
        variant="bodyXSmall"
        color={JoonUIColor.text.inverted}
        style={{ whiteSpace: "nowrap" }}
      >
        {t(badgeInfo.textKey)}
      </Typography>
    </div>
  )
}

const getBadgeInfo = (
  status: QuestStatus
): {
  color: JoonColorExpanded
  textKey:
    | "STATUS_IN_REVIEW"
    | "QB_TAB_COMPLETED"
    | "STATUS_INCOMPLETE"
    | "QB_TAB_SKIPPED"
    | "QB_TAB_REJECTED"
} => {
  switch (status) {
    case QuestStatus.COMPLETED:
      return {
        color: JoonUIColor.semantic.info,
        textKey: "STATUS_IN_REVIEW",
      }
    case QuestStatus.VERIFIED:
    case QuestStatus.REDEEMED:
      return {
        color: JoonUIColor.semantic.success,
        textKey: "QB_TAB_COMPLETED",
      }
    case QuestStatus.OPEN:
    case QuestStatus.RETRY:
      return {
        color: JoonUIColor.background.disabled,
        textKey: "STATUS_INCOMPLETE",
      }
    case QuestStatus.SKIPPED:
      return {
        color: JoonUIColor.semantic.warning,
        textKey: "QB_TAB_SKIPPED",
      }
    case QuestStatus.REJECTED:
    case QuestStatus.REJECTED_VIEWED:
      return {
        color: JoonUIColor.semantic.destructive,
        textKey: "QB_TAB_REJECTED",
      }
  }
}

export default StatusBadge
